export const educationData = [
    {
        id: 1,
        institution: 'DHA Education System',
        course: 'Higher Secondary Education',
        startYear: '2007',
        endYear: '2015'
    },
    {
        id: 2,
        institution: 'Lahore Garrison University',
        course: 'Bachelor of Computer Science',
        startYear: '2020',
        endYear: '2024'
    },
    {
        id: 3,
        institution: 'Information Technology University',
        course: 'Master of Data Science',
        startYear: '2026',
        endYear: 'Present'
    },
]